import { Component, inject, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { MedecinRowComponent } from '../medecin-row/medecin-row.component';
import { TuiTable } from '@taiga-ui/addon-table';
import { AsyncPipe } from '@angular/common';
import { TuiPagination } from '@taiga-ui/kit';
import { RouterLink } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UserList } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { Role } from '../../models/role';

@Component({
  selector: 'app-medecin-list',
  standalone: true,
  imports: [
    MedecinRowComponent,
    TuiTable,
    AsyncPipe,
    TuiPagination,
    RouterLink,
  ],
  templateUrl: './medecin-list.component.html',
  styleUrl: './medecin-list.component.scss',
})
export class MedecinListComponent {
  @Input() nom: string | undefined;
  @Input() role: Role | undefined;

  private readonly userService = inject(UserService);
  protected readonly authService = inject(AuthService);

  protected length = 1000;

  public userList$!: Observable<UserList>;

  changementDePage(page: number) {
    this.userList$ = this.userService.pullList(
      page + 1,
      undefined,
      this.nom,
      this.role?.id,
    );
  }

  ngOnInit(): void {
    this.userList$ = this.userService.pullList(
      undefined,
      undefined,
      this.nom,
      this.role?.id,
    );
  }

  ngOnChanges(): void {
    this.userList$ = this.userService.pullList(
      undefined,
      undefined,
      this.nom,
      this.role?.id,
    );
  }
}
